import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="not-found animated-container">
      <h1 className="bounce">404</h1>
      <p className="fade-in">Oops! The page you are looking for doesn't exist.</p>
      <Link to="/" className="fade-in delay">Go back to Home</Link>
    </div>
  );
};

export default NotFound;
